import { Bars2Icon } from '@heroicons/react/24/outline'

export type Page =
  | 'chat'
  | 'candidates'
  | 'shortcuts'
  | 'scene-list'
  | 'scene-map'
  | 'scene-data'
  | 'shows'
  | 'fans'
  | 'jontha-info'
  | 'mod-log'
  | 'sync'

interface NavBarProps {
  onMenuOpen: () => void
}

export default function NavBar({ onMenuOpen }: NavBarProps) {
  return (
    <div
      style={{
        flexShrink: 0,
        height: 48,
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        background: 'var(--bg)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
      }}
    >
      <button
        onClick={onMenuOpen}
        aria-label="Open menu"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 4,
          color: 'var(--accent)',
        }}
      >
        <Bars2Icon style={{ width: 22, height: 22 }} />
      </button>
    </div>
  )
}
